import { Box, Paper } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from './hook-form-error';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface InputFieldProps {
    label?: string;
    placeHolder?: string;
    name: string;
    onChange?: any;
}

export const FormRichTextField = ({ label, name, placeHolder, onChange }: InputFieldProps): any => {

    const { control } = useFormContext();
    const handleChange = (val: any) => {
        onChange(val);
    };
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // formatting buttons
            // [{ list: 'ordered' }, { list: 'bullet' }],         // lists
            // ['blockquote', 'code-block'],
            ['link'],
            ['clean'],                                         // remove formatting button
            // No heading dropdown included here
        ]
    };


    return (
        <div className="form-group">
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, onBlur, value } }) => (
                    <Box
                        sx={{
                            '& .ql-editor': {
                                minHeight: '150px',
                                fontSize: '16px',
                            },
                        }}
                    >
                        <Paper elevation={0}>
                            <ReactQuill
                                theme="snow"
                                value={value}
                                placeholder={placeHolder}
                                modules={modules}
                                onChange={(e) => {
                                    onChange(e);
                                    handleChange(e);
                                }}
                            />
                        </Paper>
                    </Box>
                )}
            />
            <FormError name={name} />
        </div>
    );
};

FormRichTextField.defaultProps = {
    label: undefined,
    placeHolder: undefined,
    onChange: () => {
        return;
    },
};

export default FormRichTextField;
